import React, { useEffect } from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="privacy-page">
            <div className="container">
                <h1 className="privacy-title">Privacy Policy – Growing Fields Organics</h1>
                <p className="privacy-intro">Growing Fields Organics values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data.</p>

                <div className="privacy-content">
                    <section className="privacy-section">
                        <h2>Information We Collect</h2>
                        <p>
                            We may collect personal information such as your name, contact details, delivery address, and order-related information when you use our website or place an order.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>Use of Information</h2>
                        <p>The information collected is used to:</p>
                        <ul>
                            <li>Process and fulfill orders</li>
                            <li>Communicate order updates and respond to inquiries</li>
                            <li>Improve our website, products, and services</li>
                        </ul>
                        <p>We do not sell or misuse your personal information.</p>
                    </section>

                    <section className="privacy-section">
                        <h2>Payment Information</h2>
                        <p>
                            Payments made on our website are processed through secure third-party payment gateways. Growing Fields Organics does not store or have access to your card or banking details.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>Data Protection</h2>
                        <p>
                            We take reasonable steps to protect your personal information from unauthorized access, misuse, or disclosure.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>Third-Party Services</h2>
                        <p>
                            Our website may use third-party services such as payment providers or logistics partners solely for order processing. These services have their own privacy practices.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>Cookies</h2>
                        <p>
                            Our website may use cookies to improve user experience and website functionality. You can manage or disable cookies through your browser settings.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>Your Consent</h2>
                        <p>
                            By using our website, you consent to the collection and use of information as described in this policy.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>Policy Updates</h2>
                        <p>
                            This Privacy Policy may be updated from time to time. Continued use of the website indicates acceptance of the updated policy.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>Contact Us</h2>
                        <p>
                            If you have any questions regarding this Privacy Policy, please contact us through the details provided on our website.
                        </p>
                    </section>

                    <section className="privacy-section last-updated">
                        <p><strong>Last updated: January 2026</strong></p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
